import { UfoOutlineIcon } from './UfoOutlineIcon';

/**
 * author: Michael Irigoyen
 * id A0C08D07-838C-426F-8EA5-EBCA5C117684
 * name ufo-outline
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ufo-outline.svg
 * tags
 */
export const UnidentifiedFlyingObjectOutlineIcon = UfoOutlineIcon;
export default UnidentifiedFlyingObjectOutlineIcon